<script lang="ts">
	import tshirtPhoto from "@assets/images/mcr2025-tshirt.jpg?webp&h=315&imagetools";
	import { genderNameMap } from "@core/schema/names/genderNameMap.js";
	import { tShirtSizeNameMap } from "@core/schema/names/tShirtSizeNameMap.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import Formatted from "./common/Formatted.svelte";
	import Media from "./common/Media.svelte";

	const { tenant } = getGlobalTemplateProps();
</script>

<div class="bg-white rounded-md px-4 py-4 min-w-80">
	<Media class="w-full" source={{ src: tshirtPhoto, type: "image/svg+xml" }} width={315} height={315} alt="T-shirt" />
	<h4 class="text-[1.25rem] max-w-48 mb-4 mt-2"><Formatted text="Championship T-Shirt" /></h4>

	<div class="flex flex-wrap gap-1 mt-2">
		{#each Object.entries(genderNameMap) as [value, name] (value)}
			<label for="tShirtGender-{value}" class="cursor-pointer group relative">
				<input
					type="radio"
					id="tShirtGender-{value}"
					name="tShirtGender"
					{value}
					required
					class="absolute inset-0 opacity-0 pointer-events-none"
				/>
				<span
					class={[
						"inline-grid uppercase place-items-center w-fit h-10 text-center border-2 rounded-md text-sm font-bold bg-light-100 px-1 py-1 border-light-100 group-has-[input:checked]:border-black",
					]}
				>
					{name[tenant.locale]}
				</span>
			</label>
		{/each}
	</div>
	<div class="flex flex-wrap gap-1 mt-2">
		{#each Object.entries(tShirtSizeNameMap) as [value, name] (value)}
			<label for="tShirtSize-{value}" class="cursor-pointer group relative">
				<input
					type="radio"
					id="tShirtSize-{value}"
					name="tShirtSize"
					{value}
					required
					class="absolute inset-0 opacity-0 pointer-events-none"
				/>
				<span
					class={[
						"inline-grid uppercase place-items-center w-10 text-center border-2 rounded-md text-sm font-bold bg-light-100 px-1 py-1 aspect-square border-light-100 group-has-[input:checked]:border-black",
					]}
				>
					{name[tenant.locale]}
				</span>
			</label>
		{/each}
	</div>
</div>
